import { render, staticRenderFns } from "./CostBreakdown.vue?vue&type=template&id=61c4eba0&scoped=true&"
import script from "./CostBreakdown.vue?vue&type=script&lang=js&"
export * from "./CostBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdown.vue?vue&type=style&index=0&id=61c4eba0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c4eba0",
  null
  
)

export default component.exports